import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const SqFoot = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '22px'}
      height={size || '22px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.001,11.348l8.146-8.14v16.29H2.853L11.001,11.348z"
        stroke={color || 'currentColor'}
      />
      <path d="M12.18,12.528l-1.158-1.15" stroke={color || 'currentColor'} />
      <path d="M14.426,10.288l-1.158-1.16" stroke={color || 'currentColor'} />
      <path d="M16.672,8.038l-1.158-1.16" stroke={color || 'currentColor'} />
      <path d="M9.934,14.778l-1.158-1.16" stroke={color || 'currentColor'} />
      <path d="M7.688,17.028l-1.158-1.16" stroke={color || 'currentColor'} />
      <path d="M15.97,11.678v4.64h-4.646L15.97,11.678z" stroke={color || 'currentColor'} />
    </StyledSvg>
  );
};
